import { useState, useEffect } from 'react';
// API
import Api from '../../API';
// helpers
import {
  getUserBooksFromSessionStorage,
  writeUserBooksToSessionStorage,
} from '../../utils/helpers';

const initialState = {
  books_list: [],
  total_results: 0,
};

export const useUserBooksFetch = () => {
  const [userBooksState, setUserBooksState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const favouriteList = async () => {
    try {
      setLoading(true);
      setError(false);

      const savedBooks = getUserBooksFromSessionStorage();
      if (savedBooks) {
        setUserBooksState({ ...savedBooks });
        setLoading(false);
        return;
      }

      const books = await Api.fetchUserBooks();
      writeUserBooksToSessionStorage(books);
      setUserBooksState({ ...books });
    } catch (error) {
      console.error(error.message);
      setError(true);
    }

    setLoading(false);
  };

  // first render
  useEffect(() => {
    favouriteList();
  }, []);

  return { userBooksState, loading, error };
};
